var _a;
import { InsuranceType } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[InsuranceType.Epo] = 'EPO',
    _a[InsuranceType.Hmo] = 'HMO',
    _a[InsuranceType.Other] = 'Other',
    _a[InsuranceType.Ppo] = 'PPO',
    _a[InsuranceType.PpoHra] = 'PPO-HRA',
    _a[InsuranceType.PpoHsa] = 'PPO-HSA',
    _a[InsuranceType.Rbp] = 'RBP',
    _a);
export var InsuranceTypeEnum = {
    name: 'InsuranceType',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
